import React, { useState, useContext, useEffect } from "react";
import JoditEditor from "../../components/Editor";
import {
  useToast,
  Box,
  Button,
  Text,
  Input,
  Stack,
  FormControl,
  Tabs,
  Tab,
  TabList,
  Select,
  Tooltip,
  Badge,
} from "@chakra-ui/react";
import { OrderContext } from "../../contexts/Order";
import { ProlabContext } from "../../contexts/Prolab";

export default function TeachingPills() {
  const toast = useToast();
  const [title, setTitle] = useState("");
  const {
    listPillsProlabApi,
    listPillsSubcategoryApi
  } = useContext(ProlabContext);
  const [categoryName, setCategoryName] = useState("");
  const [categories, setCategories] = useState("");
  const [categoryId, setCategoryId] = useState(4);
  const { learningCategoriesApi } = useContext(OrderContext);
  const [pills, setPills] = useState("");
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSubcategory, setSelectedSubcategory] = useState();
  
  function limitToTwoWords(text) {
    if (text.length > 16) {
      const islimitWords = true;
      return {text: text.slice(0, 16) + " ...", islimitWords}
    }
    return text;
  }

  async function listPills() {
    try {
      const response = await listPillsProlabApi(categoryId);
      console.log(response);
      setPills(response.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }

  async function getCategoriesApi() {
    try {
      const response = await learningCategoriesApi();
      const categories = response.data?.[0].filter(item => item.feedback_category_id !== null);
      const categoriesOrdered = [...categories]?.sort((a, b) => {
        const nameA = a.category?.toLowerCase() || "";
        const nameB = b.category?.toLowerCase() || "";
        return nameA.localeCompare(nameB);
      });
      console.log(categoriesOrdered);
      setCategories(categoriesOrdered);
    } catch (error) {
      console.log(error);
    }
  }

  async function listPillsCategory(id) {
    try {
      const response = await listPillsProlabApi(id);
      console.log(response);
      setPills(response.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }
  async function listPillsSubcategory(id, sub) {
    try {
      const response = await listPillsSubcategoryApi(id, sub);
      console.log(response);
      setPills(response.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }
  const handleCategoryClick = (category) => {
    const newSelectedCategory = category.id === selectedCategory ? null : category.id;
    
    setSelectedCategory(newSelectedCategory);
    setCategoryId(category.id);
    setCategoryName(category.category);
    listPillsCategory(category.id);
    setSelectedSubcategory(null);
  };
  const handleSubcategoryClick = (sub) => {
    setSelectedSubcategory(sub.id);
    listPillsSubcategory(categoryId, sub.id);
  };
  useEffect(() => {
    setTimeout(() => {
      getCategoriesApi();
    }, 1000); // Ag

    listPills();
  }, []);

  return (
    <>
      {categories && (
        <>
          <Tabs
            variant="soft-rounded"
            colorScheme="blackAlpha"
            backgroundColor="white"
          >
            <Box
              w={"250px"}
              justifyContent={"center"}
              mt={"370px"}
              display={"block"}
              position={"absolute"}
              left={"-15px"}
              backgroundColor={"#ffff"}
              p={8}
              borderRadius={"15px "}
              boxShadow={"0px 7px 16px 4px #EAEAEA"}
            >
              <Text>Categorias</Text>
              <TabList display={"block"} borderBottom={"0"}>
                {categories.map((category) => {
                  const { text, islimitWords } = limitToTwoWords(
                    category.category
                  );
                  const hasSubcategories =
                    category.subcategories_continuing_learning?.length > 0;

                  return (
                    <Box key={category.id}>
                      {islimitWords ? (
                        <Tooltip
                          label={category.category}
                          fontSize="sm"
                          hasArrow
                          bg="white"
                          color="black"
                        >
                          <Tab
                            mt={"1.5px"}
                            fontSize={"14px"}
                            _hover={{
                              backgroundColor: "black",
                              color: "white",
                            }}
                            _selected={{
                              backgroundColor: "black",
                              color: "white",
                            }}
                            onClick={() => handleCategoryClick(category)}
                          >
                            {text}
                          </Tab>
                        </Tooltip>
                      ) : (
                        <Tab
                          mt={"1.5px"}
                          fontSize={"14px"}
                          _hover={{ backgroundColor: "black", color: "white" }}
                          _selected={{
                            backgroundColor: "black",
                            color: "white",
                          }}
                          onClick={() => handleCategoryClick(category)}
                        >
                          {category.category}
                        </Tab>
                      )}

                      {hasSubcategories && selectedCategory === category.id && (
                        <Box ml={4} mt={2}>
                          {category.subcategories_continuing_learning.map(
                            (sub) => (
                              <Tab
                                key={sub.id}
                                fontSize={"12px"}
                                textAlign="left"
                                justifyContent="flex-start"
                                _hover={{
                                  backgroundColor: "gray.600",
                                  color: "white",
                                }}
                                onClick={() => handleSubcategoryClick(sub)}
                              >
                                {sub.name}
                              </Tab>
                            )
                          )}
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </TabList>
            </Box>
          </Tabs>

          <Box marginTop={"110px"}>
            {pills &&
              pills.map((index) => (
                <Box
                  key={index.id}
                  margin={"20px"}
                  bg={"#ffff"}
                  borderRadius={"15px "}
                  boxShadow={"0px 7px 16px 4px #EAEAEA"}
                  p={5}
                  width={"75%"}
                  ml={"250px"}
                >
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    borderBottom={"1px"}
                    borderColor={"#D2D1D166"}
                  >
                    <Text fontSize={"20px"}>Pílula Expert</Text>

                    <Box
                      m={5}
                      gap={3}
                      display={"flex"}
                      justifyContent={"end"}
                      alignItems={"center"}
                    ></Box>
                  </Box>

                  <Box
                    mt={"20px"}
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"flex-start"}
                  >
                    <Text
                      p={2}
                      borderRadius={"20px"}
                      background={"black"}
                      color={"white"}
                      fontSize={"14px"}
                    >
                      {index.category_name}{" "}
                    </Text>
                    <Box ml={2}>
                      {index?.tags?.map((tag, tagIndex) => (
                        <Badge
                          key={tagIndex}
                          display="inline-block"
                          bg="green.200"
                          color="green.800"
                          borderRadius="full"
                          p={2}
                          mr={2}
                          position="relative"
                        >
                          {tag.category_name}
                        </Badge>
                      ))}
                    </Box>
                  </Box>
                  <Box ml={1} mt={4}>
                    {index?.subs?.map((sub) => (
                      <Box
                        key={sub.id}
                        display="inline-block"
                        bg="gray.200"
                        color="gray.800"
                        borderRadius="full"
                        fontSize="xs"
                        p={1}
                        mr={2}
                        position="relative"
                      >
                        {sub.category_name}
                      </Box>
                    ))}
                  </Box>
                  <Box mt={"20px"} mb={"15px"}>
                    <Text fontSize={"24px"}>{index.learning_pills}</Text>
                  </Box>
                  <Box>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: index.description,
                      }}
                    />
                  </Box>
                </Box>
              ))}
          </Box>
        </>
      )}
    </>
  );
}
